<div *ngIf="!whatIfIsEnabled" translate>
  <div class="alert cds-alert alert-danger" role="alert">
    <div class="cds-alert-icon">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    <div class="cds-alert-content">
      {{ "warning_whatif_blocked" | translate }}
    </div>
  </div>
</div>

<div class="col-12" *ngIf="isPermissionError && whatIfIsEnabled">
  <div class="alert cds-alert alert-danger" role="alert">
    <div class="cds-alert-icon">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    <div class="cds-alert-content">
      {{ "You do not have permission to access this page." | translate }}
    </div>
  </div>
</div>
<appspinner [startSpinner]="nodeService.showAppLoader"></appspinner>

<div
  class="col-12"
  *ngIf="
    !nodeService.showAppLoader &&
    !isPermissionError &&
    whatIfIsEnabled &&
    errorMessage
  "
>
  <div class="alert cds-alert alert-danger" role="alert">
    <div class="cds-alert-icon">
      <i class="fa-solid fa-triangle-exclamation"></i>
    </div>
    <div class="cds-alert-content">{{ errorMessage }}</div>
  </div>
</div>

<ng-container *ngIf="whatIfIsEnabled">
  <h6 class="mb-1">
    {{ "Available What-if simulations for process :" | translate }}
    <h6 class="badge cds-badge active text-bg-info">
      {{ nodeService.currentProcessName }}
    </h6>
  </h6>
  <div class="card cds-card-shadow">
    <div class="card-body">
      <div class="col-12 mb-3">
        <input
          class="form-control searchBox"
          placeholder="{{ 'Quick Filter' | translate }}"
          [(ngModel)]="searchText"
        />
      </div>
      <!--Actions for first table-->
      <div class="col-12 text-center">
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="whatIfName ? false : true"
          title="{{ 'Delete' | translate }}"
          (click)="deleteWhatIf(whatIfName)"
        >
          <i class="fa fa-trash p-1" aria-hidden="true"></i
          >{{ "Delete" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="whatIfName ? false : true"
          title="{{ 'Refresh' | translate }}"
          (click)="refreshWhatIf()"
        >
          <i class="fa fa-refresh p-1" aria-hidden="true"></i
          >{{ "Refresh" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="whatIfName ? false : true"
          title="{{ 'Stop' | translate }}"
          (click)="stopWhatIf(whatIfName)"
        >
          <i class="fa fa-stop p-1" aria-hidden="true"></i
          >{{ "Stop" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="whatIfName ? false : true"
          title="{{ 'Play' | translate }}"
          (click)="startWhatIf(whatIfName)"
        >
          <i class="fa fa-play p-1" aria-hidden="true"></i
          >{{ "Play" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          title="{{ 'Load From Local' | translate }}"
          (click)="loadTheWhatIf(templateLoad, false)"
        >
          <i class="fa fa-spinner p-1" aria-hidden="true"></i
          >{{ "Load From Local" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          title="{{ 'Load From Production' | translate }}"
          (click)="loadTheWhatIf(templateLoad, true)"
        >
          <i class="fa fa-spinner p-1" aria-hidden="true"></i
          >{{ "Load From Production" | translate }}
        </button>
        <hr class="mb-3" />
      </div>
      <!--First table-->
      <div class="col-12">
        <table
          aria-describedby="table-proc-whatif"
          class="table table-striped"
          [mfData]="
            whatIfParentTblData
              | filter: 'id,notes,status,progress,updatedDt,user' : searchText
          "
          #mf="mfDataTable"
          [mfRowsOnPage]="15"
          mfSortBy="id"
        >
          <thead>
            <tr>
              <th></th>
              <th>
                <mfDefaultSorter by="id">{{
                  "Code" | translate
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="notes">{{
                  "Notes" | translate
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="status">{{
                  "Status" | translate
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="progress">{{
                  "Completed" | translate
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="updatedDt">{{
                  "Date" | translate
                }}</mfDefaultSorter>
              </th>
              <th>
                <mfDefaultSorter by="user"
                  >{{ "User" | translate }}
                </mfDefaultSorter>
              </th>
            </tr>
          </thead>
          <tbody *ngIf="whatIfParentTblData.length > 0">
            <tr
              class="cursor"
              *ngFor="let value of mf.data; let index"
              [ngStyle]="{
                'background-color':
                  value.id === whatIfName ? 'antiquewhite' : '',
              }"
            >
              <td>
                <input
                  id="{{ value.id }}"
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  (click)="showVariablesDetails(value)"
                />
              </td>
              <td>{{ value.id }}</td>
              <td>{{ value.notes }}</td>
              <td>{{ value.status | statusPipe }}</td>
              <td>{{ value.progress }}</td>
              <td>{{ value.updatedDt }}</td>
              <td>{{ value.user }}</td>
            </tr>
          </tbody>
          <tfoot
            *ngIf="
              (
                whatIfParentTblData
                | filter: 'id,notes,status,progress,updatedDt,user' : searchText
              ).length > 15
            "
          >
            <tr>
              <td colspan="10">
                <mfBootstrapPaginator
                  [rowsOnPageSet]="[15, 50, 100]"
                ></mfBootstrapPaginator>
              </td>
            </tr>
          </tfoot>
        </table>
        <div
          class="alert cds-alert alert-danger"
          role="alert"
          *ngIf="whatIfParentTblData.length === 0"
        >
          <div class="cds-alert-icon">
            <i class="fa-solid fa-triangle-exclamation"></i>
          </div>
          <div class="cds-alert-content">
            {{ "No records found." | translate }}
          </div>
        </div>
      </div>
      <hr class="mt-5" />
      <!--Actions linked to second table/whatif execution-->
      <div class="col-12 text-center">
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="whatIfName ? false : true"
          title="{{ 'Save complete Input file' | translate }}"
          (click)="
            saveInputFile(
              template,
              subInfoOfWhatIfData,
              'SaveCompleteInputFile'
            )
          "
        >
          {{ "Save complete Input file" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="isActiveWhatifSuccessFlag && isActiveWhatifBothFlag"
          title="{{ 'Save Output for Successful Req Only' | translate }}"
          (click)="
            saveInputFile(template, subInfoOfWhatIfData, 'SaveOutputSuccessReq')
          "
        >
          {{ "Save Output for Successful Req Only" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="isActiveWhatifBothFlag"
          title="{{ 'Save Input for Successful Req Only' | translate }}"
          (click)="
            saveInputFile(template, subInfoOfWhatIfData, 'SaveInputSuccessReq')
          "
        >
          {{ "Save Input for Successful Req Only" | translate }}
        </button>
      </div>
      <div class="col-12 text-center">
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="isBenchmarkFlag"
          title="{{ 'Save Benchmark Output' | translate }}"
          (click)="
            saveInputFile(template, subInfoOfWhatIfData, 'SaveBenchmarkReq')
          "
        >
          {{ "Save Benchmark Output" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="isActiveWhatifBothFlag"
          title="{{ 'Save Input for Unsuccessful Req Only' | translate }}"
          (click)="
            saveInputFile(
              template,
              subInfoOfWhatIfData,
              'SaveInputUnsuccessReq'
            )
          "
        >
          {{ "Save Input for Unsuccessful Req Only" | translate }}
        </button>
        <button
          class="btn btn-primary btn-sm m-1"
          [disabled]="isActiveWhatifUnsuccessFlag && isActiveWhatifBothFlag"
          title="{{
            'Save Output for Unsuccessful Req Only (error log)' | translate
          }}"
          (click)="
            saveInputFile(
              template,
              subInfoOfWhatIfData,
              'SaveOutputUnsuccessReqErrorLog'
            )
          "
        >
          {{ "Save Output for Unsuccessful Req Only (error log)" | translate }}
        </button>
      </div>
      <hr class="mb-5" />
      <!--Second Table-->
      <div class="col-12">
        <table
          aria-describedby="table-proc-whatifChild"
          class="table table-striped"
        >
          <thead>
            <tr class="table-header-font-color">
              <th>{{ "Current Exec Results" | translate }}</th>
              <th>{{ "Results" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>{{ "Processed Requests :" | translate }}</strong>
              </td>
              <td>{{ subInfoOfWhatIfData.numberOfProcessedRecords }}</td>
            </tr>
            <tr>
              <td>
                <strong>{{ "Successful Requests :" | translate }}</strong>
              </td>
              <td>{{ subInfoOfWhatIfData.numberOfRegularRecords }}</td>
            </tr>
            <tr>
              <td>
                <strong>{{ "Unsuccessful Requests :" | translate }}</strong>
              </td>
              <td>{{ subInfoOfWhatIfData.numberOfIrregularRecords }}</td>
            </tr>
            <tr>
              <td>
                <strong>{{ "Execution Time (sec.) :" | translate }}</strong>
              </td>
              <td>{{ subInfoOfWhatIfData.executionTimeInSeconds }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

 
  <ng-template #template tabindex="-1" class="modal fade cds-modal" let-modal>
    <div class="modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" translate>
            {{ "Download Whatif :" | translate }}
            <h5 class="badge cds-badge active text-bg-info">
              {{ whatIfName }}
            </h5>
          </h5>
          <button
            type="button"
            class="btn-close"
            (click)="modal.dismiss()"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <appspinner [startSpinner]="showAppLoader"></appspinner>
          <div class="col-12" *ngIf="isErrorFlag">
            <div class="alert cds-alert alert-danger" role="alert">
              <div class="cds-alert-icon">
                <i class="fa-solid fa-triangle-exclamation"></i>
              </div>
              <div class="cds-alert-content">
                {{ "File name is required" | translate }}
              </div>
            </div>
          </div>
          <form [formGroup]="whatIfForm" novalidate>
            <div class="row">
              <div class="col-6">
                <label class="form-label">
                  {{ "File Name" | translate }}
                </label>
                <input
                  placeholder="{{ 'File Name' | translate }}"
                  class="form-control"
                  formControlName="fileName"
                  [disabled]="showAppLoader"
                  type="text"
                />
              </div>
              <div class="col-6">
                <label class="form-label">
                  {{ "Content Type" | translate }}
                </label>
                <input
                  placeholder="{{ 'Content Type' | translate }}"
                  class="form-control"
                  formControlName="contentType"
                  [disabled]="true"
                  type="text"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            [disabled]="showAppLoader"
            type="submit"
            class="btn btn-primary"
            (click)="downloadTheWhatIf()"
          >
            {{ "Save" | translate }}
          </button>
          <button
            (click)="cancel()"
            [disabled]="showAppLoader"
            type="button"
            class="btn btn-default"
          >
            {{ "Close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template
    #templateLoad
    tabindex="-1"
    class="modal fade cds-modal"
    let-modal
  >
    <div class="modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title pull-left" *ngIf="loadWhatIf === true">
            {{ "Load From Production" | translate }}
          </h5>
          <h5 class="modal-title pull-left" *ngIf="loadWhatIf === false">
            {{ "Load From Local" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            (click)="closeForPopup()"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form [formGroup]="whatIfLoadForm" role="form">
            <!--progressbar-->
            <div class="progress" role="progressbar" *ngIf="progress > 0" aria-label="Loading Progress">
              <div
                class="progress-bar progress-bar-striped bg-info"
                [style.width.%]="progress"
              >
                {{ progress }}%
              </div>
            </div>
            <!--form-->
            <div class="row">
              <div class="col-12">
                <h6>{{ "Notes" | translate }} :</h6>
                <input
                  id="notes"
                  class="form-control"
                  type="text"
                  placeholder="{{ 'Notes' | translate }}"
                  formControlName="notes"
                  maxlength="100"
                />
              </div>
              <!--ONLY load from LOCAL-->
              <div class="col-12" *ngIf="loadWhatIf === false">
                <div class="card mt-2 p-3">
                  <h6 class="card-title">
                    {{ "Local File Upload" | translate }} :
                  </h6>
                  <input
                    id="file1"
                    type="file"
                    class="hidden"
                    accept="{{ acceptType }}"
                    ng2FileSelect
                    [uploader]="uploader"
                    (change)="getFileForLoad()"
                  />
                  <div *ngIf="fileErrorMessage" class="cds-form-control-error">
                    {{ fileErrorMessage | translate }}
                  </div>
                </div>
              </div>
              <!--ONLY load from PROD-->
              <div class="col-12" *ngIf="loadWhatIf === true">
                <div class="card mt-2 p-3">
                  <!--DATE-->
                  <div class="col-12 mb-3">
                    <div class="card mt-2 p-3">
                      <h6 class="card-title">{{ "Date" | translate }} :</h6>
                      <div class="row">
                        <div class="col-6">
                          <label class="form-label">{{
                            "Date from" | translate
                          }}</label>
                          <div class="input-group">
                            <input
                              [readonly]="true"
                              (ngModelChange)="dateChanged($event)"
                              class="form-control"
                              placeholder="yyyy-mm-dd"
                              name="dp"
                              formControlName="fromDate"
                              standalone="true"
                              ngbDatepicker
                              #d="ngbDatepicker"
                            />
                            <button
                              class="btn btn-outline-secondary bi bi-calendar3"
                              (click)="d.toggle()"
                              type="button"
                              aria-label="Toggle Datepicker"
                            >
                              <i class="fa fa-calendar" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        <div class="col-6">
                          <label class="form-label">{{
                            "Date to" | translate
                          }}</label>
                          <div class="input-group">
                            <input
                              [readonly]="true"
                              (ngModelChange)="dateChanged($event)"
                              class="form-control"
                              placeholder="yyyy-mm-dd"
                              name="dp"
                              formControlName="toDate"
                              standalone="true"
                              ngbDatepicker
                              #d2="ngbDatepicker"
                            />
                            <button
                              class="btn btn-outline-secondary bi bi-calendar3"
                              (click)="d2.toggle()"
                              type="button"
                              aria-label="Toggle Datepicker"
                            >
                              <i class="fa fa-calendar" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                        <div
                          class="cds-form-control-error"
                          *ngIf="isDateValidation"
                        >
                          {{
                            "INVALID DATE RANGE : From date should not be greater than to date."
                              | translate
                          }}
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <!--EXTRACTION-->
                  <h6 class="card-title mb-2">
                    {{ "Extraction Criteria" | translate }} :
                  </h6>
                  <div class="card p-2">
                    <div class="row mb-2">
                      <div class="col-4 mt-2">
                        <div class="form-check">
                          <label class="form-label">
                            {{ "Process Version" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControleName="processVersionFlag"
                            (change)="checkProcessVersion()"
                          />
                        </div>
                      </div>
                      <div class="col-8">
                        <input
                          placeholder="{{ 'Number' | translate }}"
                          class="form-control"
                          [disabled]="processVFlag"
                          formControlName="processVersion"
                          maxlength="100"
                        />
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-4 mt-2">
                        <div class="form-check">
                          <label class="form-label">
                            {{ "Request Code" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControleName="requestCodeFlag"
                            (change)="checkRequestCode()"
                          />
                        </div>
                      </div>
                      <div class="col-8">
                        <input
                          placeholder="{{ 'Request Code' | translate }}"
                          class="form-control"
                          [disabled]="requestCFlag"
                          formControlName="requestID"
                          maxlength="100"
                        />
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-4 mt-2">
                        <div class="form-check">
                          <label class="form-label">
                            {{ "Last Call Per Request" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControleName="lastCallPerRequest"
                            (click)="lastRequest()"
                          />
                        </div>
                      </div>
                      <div class="col-8"></div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-4 mt-2">
                        <div class="form-check">
                          <label class="form-label">
                            {{ "Request Status" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControleName="requestStatusFlag"
                            (click)="checkRequestStatus()"
                          />
                        </div>
                      </div>
                      <div class="col-8">
                        <ng-select
                          [items]="requestStatusOptions"
                          bindLabel="viewValue"
                          bindValue="value"
                          placeholder="{{ 'Request Status' | translate }}"
                          formControlName="extractMode"
                        >
                        </ng-select>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-4 mt-2">
                        <div class="form-check">
                          <label class="form-label">
                            {{ "Execution Time" | translate }}
                          </label>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            formControleName="executionTimeFlag"
                            (click)="checkExecutionTime()"
                          />
                        </div>
                      </div>
                      <div class="col-4">
                        <input
                          placeholder="{{ 'From (ms)' | translate }}"
                          class="form-control"
                          [disabled]="execTFlag"
                          formControlName="fromExecTime"
                          maxlength="100"
                        />
                      </div>
                      <div class="col-4">
                        <input
                          placeholder="{{ 'To (ms)' | translate }}"
                          class="form-control"
                          [disabled]="execTFlag"
                          formControlName="toExecTime"
                          maxlength="100"
                        />
                      </div>
                    </div>
                  </div>
                  <!--SAMPLING-->
                  <h6 class="card-title mb-2 mt-3">
                    {{ "Sampling" | translate }} :
                  </h6>
                  <div class="row mb-2">
                    <div class="col-6 mt-2">
                      <input
                        placeholder="{{ 'Percentage (1-100 %)' | translate }}"
                        class="form-control"
                        formControlName="sampleInterval"
                        min="1"
                        max="100"
                        maxlength="3"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        placeholder="{{
                          'Max. number of requests' | translate
                        }}"
                        class="form-control"
                        formControlName="maxRequest"
                        maxlength="100"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <!--REPORTING-->
              <div class="col-12">
                <div class="card mt-2 p-3">
                  <h6 class="card-title">
                    {{ "I/O and Reporting Data" | translate }} :
                  </h6>
                  <div class="form-check">
                    <label class="form-label">
                      {{
                        "Fast What-if (No - What-if/Reporting analysis allowed)"
                          | translate
                      }}
                    </label>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [disabled]="true"
                      [checked]="true"
                      formControleName="fastWhatIf"
                    />
                  </div>
                  <div class="form-check">
                    <label class="form-label">{{
                      "Enable Dynamic Simulation" | translate
                    }}</label>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControleName="enableDyanamicSimulation"
                    />
                  </div>
                </div>
              </div>
              <!--OUTPUT-->
              <div class="col-12" *ngIf="loadWhatIf === true">
                <div class="card mt-2 p-3">
                  <h6 class="card-title">
                    {{ "Output Comparison" | translate }} :
                  </h6>
                  <div class="form-check">
                    <label class="form-label">
                      {{
                        "Extraction Output from the source enviorment (Benchmark)"
                          | translate
                      }}
                    </label>
                    <input
                      class="form-check-input"
                      type="checkbox"
                      formControleName="extractOutput"
                      (click)="changeExtractOutput()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-primary"
            (click)="loadWhatIf === true ? saveWhatIf() : fileChanged()"
            [disabled]="progress > 0 || isSaveFlag"
          >
            {{ "Save" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-default"
            (click)="closeForPopup()"
          >
            {{ "Close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
